<template>
    <div class="home">
        <div class="title-logo" style="color: #fff;font-size: 16px">
          YJR 云锦荣
<!--            <img src="../../assets/img/logo.png" alt="" class="logo">-->
            <img src="../../assets/icon/nav-list.png" alt="" class="nav-icon" @click="navShow=true">

        </div>
		<transition name="fade">
			<div class="nav" v-if="navShow" @click="navShow=false">
				<div class="nav-content">
					<a class="" href="#introduce" @click.prevent="navChange(1)">首页</a>
					<a class="" href="#product" @click.prevent="navChange(2)">产品矩阵</a>
					<a class="" href="#case" @click.prevent="navChange(3)">案例介绍</a>
					<router-link to="about">关于我们</router-link>
				</div>
				<img src="../../assets/icon/nav-close.png" alt="" class="nav-close">
			</div>
		</transition>
       
        <!-- 头部 -->
        <div class="title" id="introduce">
            <el-carousel :interval="5000" arrow="never" height="3.48rem">
                <el-carousel-item>
                    <div class="banner-text">
                        <div>连接一切可能</div>
                        <div>欢迎来到云锦荣 给与您的帮助,是我们最大的荣幸</div>
                    </div>
                </el-carousel-item>
                <el-carousel-item>
                    <div class="banner-text">
                        <div>云锦荣</div>
                        <div>欢迎来到云锦荣 给与您的帮助,是我们最大的荣幸</div>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
        <!-- 公司介绍 -->
        <div class="introduce">
			<div class="introduce-title">公司介绍</div>
			<div class="introduce-content">
				<img src="../../assets/img/introduce.png" alt="">
				<div class="introduce-text">
					<div>重庆云锦荣科技有限公司</div>
					<div>提供“互联网+”整体解决方案，集互联网产品研发、自媒体运营、文化传播、运营推广、商品销售、管理咨询为一体的互联网科技公司。总部位于重庆市，目前拥有员工80余人，拥有丰富的行业经验、客户案例和整合资源。</div>
					<div>拥有独立运营推广团队的微信平台服务商。</div>
				</div>
			</div>
		</div>
        <!-- 产品区 -->
		<div class="product" id="product">
			<div class="product-title">产品矩阵</div>
			<div class="product-content">
				<div class="product-item">
                    <div class="product-item-index">
						<img src="../../assets/img/product-1.png" alt="">
						<div class="product-item-text">互联网+政务</div>
						<div class="product-item-tags">
							<span>重庆交巡警</span>
							<span>暖青汇</span>
							<span>愉快办</span>
						</div>
					</div>
                    <div class="product-item-index">
						<img src="../../assets/img/product-1.png" alt="">
						<div class="product-item-text">互联网+餐饮</div>
						<div class="product-item-tags">
							<span>重庆交巡警</span>
						</div>
					</div>
					<div class="product-item-index">
						<img src="../../assets/img/product-1.png" alt="">
						<div class="product-item-text">互联网+车后</div>
						<div class="product-item-tags">
							<span>微务通</span>
						</div>
					</div>
					<div class="product-item-index">
						<img src="../../assets/img/product-1.png" alt="">
						<div class="product-item-text">互联网+旅游</div>
						<div class="product-item-tags">
							<span>村游村购</span>
						</div>
					</div>
					<div class="product-item-index">
						<img src="../../assets/img/product-1.png" alt="">
						<div class="product-item-text">互联网+农业</div>
						<div class="product-item-tags">
							<span>村务宝</span>
							<span>农展购</span>
						</div>
					</div>
				</div>
			</div>
		</div>
        <!-- 案例介绍 -->
		<div class="case" id="case">
			<div class="case-title">案例介绍</div>
			<div class="case-list">
				<div class="case-li">
					<img src="../../assets/img/case-1.png" alt="">
					<div>
						<p>“采用灵活的市场机制，引入社会力量和社会资本投入，适当开发数据增值服务功能，用市场收入反哺系统运行”——《汽车维修电子健康档案系统建设指南》
						微务通SaaS平台——汽车服务大数据平台，针对各类客户痛点提供完整解决方案</p>
						<span>微务通</span>
					</div>
				</div>
				<div class="case-li">
					<img src="../../assets/img/case-2.png" alt="">
					<div>
						<p>“暖青汇”志愿服务App是重庆首个面向志愿服务的在线移动综合服务平台。由共青团重庆市委为满足广大青年志愿需求和社交需要所打造的集专业性、互动性、开放性、便捷性于一体，涵盖志愿者线上注册、服务供需对接、服务时长记录等一站式服务。注册用户近400万，荣获 2016重庆市“互联网+”试点项目。</p>
						<span>暖青汇</span>
					</div>
				</div>
				<div class="case-li">
					<img src="../../assets/img/case-3.png" alt="">
					<div>
						<p>利用微信平台树立良好的交巡警形象，提供交巡警服务，传播交管政策法规，减少办事环节，提高公众的参与度，优化政府信息资源配置，完善政府与公众的沟通渠道，构建警民关系管理系统、实时沟通，扩展服务范围，创新电子政务新模式。</p>
						<span>重庆交巡警</span>
					</div>
				</div>
			</div>
		</div>
        <!-- 优质客户 -->
		<div class="client">
			<div class="client-title">
				<h3>更多优质客户</h3>
			</div>
			<div class="client-list">
				<img :src="item" alt="" v-for="(item,index) in clientList" :key="index">
			</div>
		</div>
        <!-- 公司地址 -->
		<div class="address">
			<div class="client-title">
				<h3>公司地址</h3>
			</div>
			<div class="">
				<Map :height="height"></Map>
			</div>
		</div>
		<!-- 回到顶部 -->
		<img src="../../assets/icon/return-top.png" alt="" class="scroll-top" @click="scrollTop" v-if="returnShow">
    </div>
</template>

<script>
import Map from "../../components/map/index.vue"
export default {
    data(){
        return{
            clientList:[
                require('../../assets/img/client-1.png'),
                require('../../assets/img/client-2.png'),
                require('../../assets/img/client-3.png'),
                require('../../assets/img/client-4.png'),
                require('../../assets/img/client-5.png'),
                require('../../assets/img/client-6.png'),
                require('../../assets/img/client-7.png'),
                require('../../assets/img/client-8.png'),
                require('../../assets/img/client-9.png'),
                require('../../assets/img/client-10.png'),
                ],
                idx:1,
                height:'2.12rem',
                navShow:false,
				screenHeight:'', //屏幕高度
				returnShow:false,  //是否显示返回顶部按钮
        }
    },
    created(){
        let i=this.$route.query.i
        if(i){
            this.idx=i?i:1
            this.navChange(i)
        }
    },
    components:{
			Map
	},
	mounted(){
		this.$nextTick(function() {
			let _this = this;
			_this.screenHeight=window.screen.height
			window.addEventListener("scroll", this.onScroll);
		});
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.onScroll)
	},
    methods:{
        navChange(i){
            if(this.idx!=i){
                this.idx=i
            }
            let anchorName=''
            if(i==1){
                anchorName='introduce'
            }else if(i==2){
                anchorName='product'
            }else if(i==3){
                anchorName='case'
            }
            this.$nextTick(_=>{
                let anchorElement = document.getElementById(anchorName);
                    /*如果对应id的锚点存在，就跳转到锚点*/
                    if(anchorElement) {
                        anchorElement.scrollIntoView();
                }
            })
        },
		onScroll(e){
			this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
			if(this.scroll>this.screenHeight){
				this.returnShow=true
			}else{
				this.returnShow=false
			}
		},
		scrollTop(){
			window.scroll({
				top:0,
				behavior:'smooth'
			})
		},
    }
}
</script>
<style lang="scss" scoped>

    .title-logo{
        height:.75rem;
        width:100%;
        position: fixed;
        left:0;
        top:0;
        box-sizing: border-box;
        z-index: 10;
        display:flex;
        align-items: center;
        justify-content: center;
        background: #000;
        .logo{
            width:1.36rem;
            height:.41rem;
        }
        .nav-icon{
            position: absolute;
            left:.27rem;
            top:50%;
            transform: translateY(-50%);
            width:.41rem;
            height:.41rem;
        }
    }
    .nav{
        position: fixed;
        left:0;
        top:0;
        z-index: 20;
        height:100%;
        width:100%;
        background:rgba(0,0,0,0.45);
        overflow: hidden;
        .nav-content{
            width:4.63rem;
            background:#fff;
            height:100%;
            overflow: hidden;
           padding-top:2.08rem;
           >a{
            display:inline-block;
            width:100%;
            box-sizing: border-box;
            padding:.17rem .82rem;
            margin-bottom:.2rem;
            font-size: 0.29rem;
            line-height: 0.34rem;
           }
        }
        .nav-close{
            position: absolute;
            left:.27rem;
            top:.41rem;
            z-index: 10;
            width:.41rem;
            height:.41rem;
        }
    }
    .title{
        width:100%;
        height:3.48rem;
        background:url('../../assets/img/banner.png') no-repeat left top;
        background-size:100% 100%;
        box-sizing: border-box;
        .banner-text{
            color: #FFFFFF;
            display:flex;
            flex-direction: column;
            justify-content: center;
            height:100%;
            padding-left:.26rem;
            >div{
                &:nth-child(1){
                    font-size: 0.41rem;
                    line-height: 0.48rem;
                    font-weight: 600;
                }
                &:nth-child(2){
                    font-size: 0.24rem;
                    line-height: 0.41rem;
                    margin-top:.2rem;
                }
            }
        }
    }
    .introduce{
		.introduce-title{
			padding-top:.68rem;
			padding-bottom:.17rem;
			text-align: center;
			color: #1D2129;
			line-height: .48rem;
			font-size: .38rem;
			font-weight: 600;
		}
		.introduce-content{
			position: relative;
			height:4.2rem;
			>img{
				position: absolute;
				left:0;
				top:0;
				width:100%;
				height:100%;
			}
			.introduce-text{
				height:100%;
				position: relative;
				z-index: 5;
				display:flex;
				flex-direction: column;
				justify-content: center;
				padding:.27rem;
				>div:nth-child(1){
					font-size:.38rem;
					color: #1D2129;
					line-height: .48rem;
				}
				>div:nth-child(2){
					font-size: .24rem;
					color: var(--main-color);
					line-height: .44rem;
					text-align: justify;
					margin:.14rem 0 .1rem;
				}
				>div:nth-child(3){
					font-size: .24rem;
					color: var(--main-color);
					line-height: .44rem;
					text-align: justify;
				}
			}
		}
	}
    .product{
        background: #EEF4FA;
		.product-title{
			padding-top:.68rem;
			padding-bottom:.14rem;
			text-align: center;
			color: #1D2129;
			line-height: .48rem;
			font-size: .38rem;
			font-weight: 600;
		}
		.product-content{
            padding:0 .27rem;
			.product-item{
				color: #FFFFFF;
				.product-item-index{
					width:100%;
					height: 2.56rem;
					position: relative;
                    margin-top:.2rem;
					>img{
						width:100%;
						height:100%;
						position: absolute;
						left:0;
						top:0;
						border-radius:.14rem;
					}
					.product-item-text{
						position: relative;
						z-index: 5;
						font-size: .41rem;
						line-height: .75rem;
						margin-left:.41rem;
						padding-top:.56rem;
					}
					.product-item-tags{
						position: absolute;
						left:0;
						bottom:0;
						z-index: 5;
						width:100%;
						border-radius:.14rem;
						box-sizing: border-box;
						padding-left:.27rem;
						background: rgba(0,0,0,0.21);
						display:flex;
						>span{
							padding:.1rem 0;
							line-height: .38rem;
							font-size: .24rem;
							margin-right:.34rem;
							&:last-child{
								margin-right:0;
							}
						}
					}
				}
							
			}
		}
	}
	.case{
		.case-title{
			padding-top:.68rem;
			padding-bottom:.34rem;
			text-align: center;
			color: #1D2129;
			line-height: .48rem;
			font-size: .38rem;
			font-weight: 600;
		}
		.case-list{
			display:flex;
            overflow: auto;
            padding:0 .37rem;
            &::-webkit-scrollbar {
                display: none;//隐藏滚动条
            }
			.case-li{
				width:5.12rem;
                flex-shrink: 0;
				border-radius: .14rem;
                box-shadow: 0rem 0.07rem 0.55rem -0.1rem rgba(151,185,255,0.24);
				background: #FFFFFF;
				height:8.09rem;
				position: relative;
                margin-right:.14rem;
				>img{
					width:100%;
					height:4.2rem;
				}
				>div{
					position: absolute;
					bottom:0;
					left:0;
					height:4.4rem;
					width:100%;
					border-radius: 0.15rem;
					z-index: 5;
					font-size: 0.24rem;
					background: #FFFFFF;
					color: var(--main-color);
					box-sizing: border-box;
					padding:.41rem .27rem;
					>p{
						line-height: .38rem;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 8;
						-webkit-box-orient: vertical;  
					}
					>span{
						position: absolute;
						bottom:.27rem;
						right:.27rem;
						font-size: 0.24rem;
						color: #000000;
						line-height: .38rem;
						padding-left:.96rem;
						&::before{
							content:'';
							height:2px;
							width:.82rem;
							background:rgba(0,0,0,0.15);
							position: absolute;
							left:0;
							top:50%;
							transform: translateY(-50%);
						}
					}
				}
			}
		}
	}
    .client,.address{
        margin-top:.68rem;
		.client-title{
			padding:0 .27rem .34rem;
			text-align: center;
			>h3{
				position: relative;
				font-weight: 400;
				color: #1D2129;
				line-height: .44rem;
				font-size: .24rem;
				&::before{
					content:'';
					width:1.81rem;
					height:2px;
					position: absolute;
					left:0;
					top:50%;
					transform: translateY(-50%);
					background:linear-gradient(-45deg, rgba(0, 0, 0, .2), rgba(0, 0, 0, 0));
				}
				&::after{
					content:'';
					width:1.81rem;
					height:2px;
					position: absolute;
					right:0;
					top:50%;
					transform: translateY(-50%);
					background:linear-gradient(45deg, rgba(0, 0, 0, .2), rgba(0, 0, 0, 0));
				}
			}
		}
		.client-list{
			display:flex;
			flex-wrap: wrap;
            justify-content: center;
			align-items: center;
			padding:0 .27rem;
			>img{
				width:33%;
				height:.65rem;
                margin-bottom:.07rem;
				
			}
		}
	}
	.scroll-top{
		position: fixed;
		z-index: 110;
		right:.27rem;
		bottom:.62rem;
		width:.82rem;
		height:.82rem;
		border-radius: 50%;
	}
	.fade-enter-active, .fade-leave-active{
		transition: all .2s ease   
	}
	.fade-enter, .fade-leave-active{
		width: 0 
	}
</style>
